import React, { useState, useRef, useEffect, useMemo } from 'react';
import { FACTOR_ENUMS, BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';
import GradeDialView from './components/GradeDialView';
import {
  getGradeDialData,
  getPotentialGradeDialData,
  isFreeUserWith1B,
  BureauMap,
} from './helpers/utils';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import {
  isFreemium,
  isPremium,
  isFreeTrial,
  UserType,
  isPlus3BPaid,
  is3BFreeTrial,
  is1BFreeTrial,
  is1BPaid,
} from 'helpers/userHelper';
import {
  providerMapping,
  factorMapping,
} from 'customHelpersPath/factorMapping.helper';
import { useFlag } from 'hook/flag.hook';
import {
  isNonControlVariationLoadedAndEnabled,
  isVariationLoadedAndEnabled,
} from 'helpers/optimizely.helper';
import { canPurchase3BReport } from 'pages_CreditReportTU/creditReportTU3B.helper';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'helpers/string.helper';
import {
  getShouldShowExpandedEngagementModule,
  removeShouldShowExpandedEngagementModule,
} from 'helpers/sessionstorage';
import {
  loadPotentialCreditProfileContainer,
  setSelectedFactorToToday,
} from 'actions/dashboard.actions';
import { useSubscriptionLandingUrl } from 'hook/subscriptionLandingUrl.hook';

export const FACTOR_ENUMS_ARRAY = Object.keys(FACTOR_ENUMS);

const GradeDialController = props => {
  const {
    profileContainer,
    potentialCreditProfileContainer,
    todayContainer,
    isFactorContainerLoading,
    profileContainerLoading,
    potentialCreditProfileContainerLoading,
    todayContainerLoading,
    selectedBureau,
    selectedFactor,
    loadTodayDashboard,
    onBureauSelection,
    userInfo,
    eventHandler,
    history,
    location,
    potentialCreditProfileContainerError,
    handleTryAgainPotentialCreditProfile,
    goToFactorPage,
  } = props;

  const { subscriptionLandingUrl } = useSubscriptionLandingUrl();

  const {
    PAYMENT_HISTORY,
    ACCOUNT_MIX,
    CREDIT_AGE,
    CREDIT_INQUIRIES,
    CREDIT_USAGE,
    POTENTIAL_CREDIT_PROFILE,
  } = FACTOR_ENUMS;

  window.addEventListener('beforeunload', function (e) {
    removeShouldShowExpandedEngagementModule();
  });

  const { creditReportState } = useSelector(state => ({
    creditReportState: state?.creditReport,
  }));
  const ableToPurchase3BReport = canPurchase3BReport({
    userInfo,
    creditReportRes: creditReportState?.creditReports,
  });

  const expPremiumReactivatePendingCancellation = useFlag(
    'premiumreactivatecancelpending_web',
  );

  const dashboarPageFlag = useFlag('dashboard_page', {
    defaultConfig: {
      excludeEngagementOffers: true,
      showEngagementModule: false,
      showPotentialScore: false,
    },
  });

  const showEngagementModuleFromFlag =
    dashboarPageFlag?.config?.showEngagementModule;

  const showPotentialScoreFromFlag =
    dashboarPageFlag?.config?.showPotentialScore;
  const isPremiumReactivatePendingCancellationUser =
    isVariationLoadedAndEnabled(expPremiumReactivatePendingCancellation);

  const expPremiumReactivateCancel = useFlag('PremiumReactivateCancel_web');
  const isPremiumReactivateCancelUser = isNonControlVariationLoadedAndEnabled(
    expPremiumReactivateCancel,
  );

  const plusLaunchWebFlag = useFlag('pluslaunch_web');
  const isPlusLaunchWebFlagEnabled =
    isNonControlVariationLoadedAndEnabled(plusLaunchWebFlag);

  const lottieAnimation = useRef();
  const donutRef = useRef(null);

  const gradeDialData = useMemo(() => {
    return getGradeDialData(profileContainer);
  }, [profileContainer]);

  const [scoreData, setScroeData] = useState([]);
  const [factorData, setFactorData] = useState({ data: [], sesameGrade: '' });
  const [currentBureau, setCurrentBureau] = useState(selectedBureau);
  const [showDonut, setShowDonut] = useState(false);
  const [isSomeBureauClicked, setIsSomeBureauClicked] = useState(false);
  const [isSomeFactorClicked, setIsSomeFactorClicked] = useState(false);
  const [showEngagement, setShowEngagement] = useState(false);
  const [eventEngagementData, setEventEngagementData] = useState(undefined);

  const [potentialScoreData, setPotentialScroeData] = useState([]);
  const [potentialFactorData, setPotentialFactorData] = useState({
    data: [],
    sesameGrade: '',
  });

  const [isPotentialView, setIsPotentialView] = useState(
    location?.search?.includes(POTENTIAL_CREDIT_PROFILE),
  );

  useEffect(() => {
    setIsPotentialView(location?.search?.includes(POTENTIAL_CREDIT_PROFILE));
  }, [location, POTENTIAL_CREDIT_PROFILE]);

  const dispatch = useDispatch();

  useEffect(() => {
    const gradeDialData = getGradeDialData(profileContainer);
    setScroeData(gradeDialData.creditScoreData);
    // Note, this is to deal with 1B and 3B users
    const creditFactorData = isFreeUserWith1B(gradeDialData)
      ? gradeDialData.creditFactorData[BureauMap[BUREAU_ENUMS.TRANS_UNION]]
      : gradeDialData.creditFactorData[
          BureauMap[currentBureau || BUREAU_ENUMS.ALL]
        ];

    const idx = FACTOR_ENUMS_ARRAY.indexOf(selectedFactor);
    if (idx === -1) {
      setIsSomeFactorClicked(false);
    }
    if (idx !== 5 && idx !== -1 && idx !== 6 && !isPotentialView) {
      setIsSomeFactorClicked(true);
    }
    const updateData = creditFactorData?.data.map(item => {
      return {
        ...item,
        focus: item.id === Number(idx + 1) ? !item.focus : item.focus,
      };
    });
    setFactorData({
      sesameGrade: creditFactorData?.sesameGrade,
      data: updateData,
    });

    const eventEngagementInfo = gradeDialData.eventInfo;
    const shouldShowExpandedEngagementModule =
      getShouldShowExpandedEngagementModule();
    if (shouldShowExpandedEngagementModule === null) {
      setShowEngagement(!isEmpty(eventEngagementInfo));
    } else {
      setShowEngagement(false);
    }
    setEventEngagementData(eventEngagementInfo);

    const potentialData = getPotentialGradeDialData(
      potentialCreditProfileContainer,
    );

    if (selectedFactor === FACTOR_ENUMS.POTENTIAL_CREDIT_PROFILE) {
      setIsSomeFactorClicked(false);
      setIsPotentialView(true);
    }

    // https://creditsesame.atlassian.net/browse/EPOD-4356
    if (
      FACTOR_ENUMS_ARRAY.includes(selectedFactor) &&
      selectedFactor !== FACTOR_ENUMS.POTENTIAL_CREDIT_PROFILE
    ) {
      setIsPotentialView(false);
    }

    setPotentialScroeData(potentialData.creditScoreData);
    setPotentialFactorData(potentialData.creditFactorData);
  }, [
    profileContainer,
    potentialCreditProfileContainer,
    currentBureau,
    selectedFactor,
    isPotentialView,
    potentialCreditProfileContainerError,
  ]);

  useEffect(() => {
    if (
      showPotentialScoreFromFlag &&
      !profileContainerLoading &&
      profileContainer &&
      !todayContainerLoading &&
      todayContainer &&
      !potentialCreditProfileContainerLoading &&
      !potentialCreditProfileContainer
    ) {
      dispatch(loadPotentialCreditProfileContainer());
    }
    // eslint-disable-next-line
  }, [
    profileContainerLoading,
    profileContainer,
    todayContainerLoading,
    todayContainer,
    potentialCreditProfileContainerLoading,
    potentialCreditProfileContainer,
  ]);

  useEffect(() => {
    if (!todayContainerLoading && todayContainer) {
      dispatch(loadPotentialCreditProfileContainer(null, false));
    }
    // eslint-disable-next-line
  }, [todayContainerLoading, todayContainer]);

  const handleClickBureauDial = bureau => {
    eventHandler(CLICK, {
      'Click Type':
        bureau === BUREAU_ENUMS.TRANS_UNION
          ? providerMapping.get(bureau) + ' Score'
          : providerMapping.get(bureau) +
            ' Score - Premium Dial Upsell 3B Gating',
      Vertical: SUBSCRIPTION_VERTICAL,
    });
    onBureauSelection(bureau);
    setCurrentBureau(bureau);
    setIsSomeBureauClicked(true);

    const idx = FACTOR_ENUMS_ARRAY.indexOf(selectedFactor);
    const updateData = gradeDialData.creditFactorData[
      BureauMap[bureau]
    ]?.data.map(item => {
      return {
        ...item,
        focus: item.id === Number(idx + 1) ? !item.focus : item.focus,
      };
    });
    setFactorData({ ...factorData, data: updateData });
  };

  const handleClickDonut = id => {
    if (isPotentialView) {
      eventHandler(CLICK, {
        'Module Name': 'Potential Factor Dial',
        'Module Position': 2,
        'Click Type': factorMapping.get(FACTOR_ENUMS_ARRAY[Number(id) - 1]),
      });

      const identifier = FACTOR_ENUMS_ARRAY[Number(id) - 1];
      const element = document.getElementById(identifier);
      element?.scrollIntoView();
    } else {
      eventHandler(CLICK, {
        'Module Position': 2,
        'Module Name': 'Grade Dial 3B',
        'Click Type': factorMapping.get(FACTOR_ENUMS_ARRAY[Number(id) - 1]),
        Vertical: SUBSCRIPTION_VERTICAL,
      });

      switch (FACTOR_ENUMS_ARRAY[Number(id) - 1]) {
        case FACTOR_ENUMS.PAYMENT_HISTORY: {
          goToFactorPage(PAYMENT_HISTORY);
          break;
        }
        case FACTOR_ENUMS.CREDIT_USAGE: {
          goToFactorPage(CREDIT_USAGE);
          break;
        }
        case FACTOR_ENUMS.CREDIT_AGE: {
          goToFactorPage(CREDIT_AGE);
          break;
        }
        case FACTOR_ENUMS.ACCOUNT_MIX: {
          goToFactorPage(ACCOUNT_MIX);
          break;
        }
        case FACTOR_ENUMS.CREDIT_INQUIRIES: {
          goToFactorPage(CREDIT_INQUIRIES);
          break;
        }
        default: {
          loadTodayDashboard();
          break;
        }
      }

      setIsSomeFactorClicked(true);
      const updateData = factorData?.data.map(item => {
        return {
          ...item,
          focus: item.id === Number(id),
        };
      });
      setFactorData({ ...factorData, data: updateData });
    }
  };

  const handleGoToCreditReports = () => {
    eventHandler(CLICK, {
      'Module Name': 'Grade Dial 3B',
      'Click Type': 'TU3B Report Link',
      Vertical: SUBSCRIPTION_VERTICAL,
    });
    history?.push('/creditReports/tabs?nav=premiumCreditReports');
  };

  const handleClickPotential = () => {
    if (!isPotentialView) {
      goToFactorPage(POTENTIAL_CREDIT_PROFILE);
    } else {
      closeFocusedFactor();
    }
    eventHandler(CLICK, {
      'Click Type': isPotentialView ? 'Potential Off' : 'Potential On',
      'Module Position': 2,
      'Module name': isPotentialView ? 'Potential' : 'Today',
      'Nav Location': 'Potential',
    });
    setIsPotentialView(!isPotentialView);
  };

  const closeFocusedFactor = () => {
    setIsSomeFactorClicked(false);
    setIsPotentialView(false);
    const updateData = factorData?.data.map(item => {
      return {
        ...item,
        focus: false,
      };
    });
    setFactorData({ ...factorData, data: updateData });
    history.push('dashboard');
    dispatch(setSelectedFactorToToday());
  };

  useEffect(() => {
    if (isPotentialView) {
      // Show donut when data lodaded or error loaded, just show it
      if (
        !potentialCreditProfileContainerLoading &&
        (potentialCreditProfileContainer ||
          potentialCreditProfileContainerError)
      ) {
        setShowDonut(true);
      }
    } else {
      if (!profileContainerLoading && profileContainer) {
        setShowDonut(true);
        setIsSomeBureauClicked(true);
      }
    }
  }, [
    isPotentialView,
    profileContainer,
    profileContainerLoading,
    potentialCreditProfileContainer,
    potentialCreditProfileContainerLoading,
    potentialCreditProfileContainerError,
  ]);

  const instructionType = React.useMemo(() => {
    const isFreemiumUser = isFreemium(userInfo);
    const isPremiumUser = isPremium(userInfo);
    const isFreeTrialUser = isFreeTrial(userInfo);
    const isPlus3BPaidUser = isPlus3BPaid(userInfo, profileContainer);

    const is3BFreeTrialUser = is3BFreeTrial(userInfo);
    const is1BFreeTrialUser = is1BFreeTrial(userInfo);
    const is1BPaidUser = is1BPaid(userInfo);

    if (isFreemiumUser && !isPremiumUser && !isFreeTrialUser) {
      return UserType.FREE_USER;
    }

    if (isPlus3BPaidUser && !isFreeTrialUser) {
      return UserType.PAID_PREMIUM_MEMBER;
    }

    if (!isFreemiumUser && isPremiumUser && isFreeTrialUser) {
      return UserType.PREMIUM_MEMBER_TRIAL;
    }

    if (!isFreemiumUser && isPremiumUser && !isFreeTrialUser) {
      return is3BFreeTrialUser || is1BFreeTrialUser || is1BPaidUser
        ? null
        : UserType.PAID_PREMIUM_MEMBER;
    }

    return UserType.FREE_USER;
  }, [userInfo, profileContainer]);

  return (
    <GradeDialView
      lottieAnimation={lottieAnimation}
      donutRef={donutRef}
      selectedFactor={selectedFactor}
      showDonut={showDonut}
      isFactorContainerLoading={isFactorContainerLoading}
      instructionPageType={instructionType}
      currentBureau={currentBureau}
      scoreData={scoreData}
      factorData={factorData}
      potentialScoreData={potentialScoreData}
      potentialFactorData={potentialFactorData}
      potentialCreditProfileContainer={potentialCreditProfileContainer}
      isSomeBureauClicked={isSomeBureauClicked}
      isSomeFactorClicked={isSomeFactorClicked}
      handleClickBureauDial={handleClickBureauDial}
      handleClickDonut={handleClickDonut}
      handleGoToCreditReports={handleGoToCreditReports}
      closeFocusedFactor={closeFocusedFactor}
      showEngagement={showEngagement}
      setShowEngagement={setShowEngagement}
      eventEngagementData={eventEngagementData}
      isPotentialView={isPotentialView}
      setIsPotentialView={setIsPotentialView}
      userInfo={userInfo}
      isPremiumReactivatePendingCancellationUser={
        isPremiumReactivatePendingCancellationUser
      }
      isPremiumReactivateCancelUser={isPremiumReactivateCancelUser}
      isPlusLaunchWebFlagEnabled={isPlusLaunchWebFlagEnabled}
      ableToPurchase3BReport={ableToPurchase3BReport}
      handleClickPotential={handleClickPotential}
      handleTryAgainPotentialCreditProfile={
        handleTryAgainPotentialCreditProfile
      }
      showEngagementModuleFromFlag={showEngagementModuleFromFlag}
      modulePosition={2}
      subscriptionLandingUrl={subscriptionLandingUrl}
      {...props}
    />
  );
};

export default GradeDialController;
